// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { injectCss } from "@insite/mobius/utilities";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import MobiusStyledComponentProps from "@insite/mobius/utilities/MobiusStyledComponentProps";
import { CustomAppState } from "@werner/App/Store/Reducers";
import { xScreen } from "@werner/XDL/Utilities";
import React, { FC } from "react";
import styled, { css } from "styled-components";

interface XngStickyProps {
    css?: StyledProp<XngStickyComponentProps>;
    stickyOffset?: string;
    stopBreakpoint?: "xs" | "sm" | "md" | "lg" | "xl";
    [key: string]: any;
}

export type XngStickyComponentProps = MobiusStyledComponentProps<"div", XngStickyProps>;

const XngStickyWrapper = styled.div<XngStickyComponentProps>`
    position: sticky;
    top: ${({ stickyOffset }) => `${stickyOffset}`};
    ${({ stopBreakpoint }) => css`
        ${xScreen("lte", stopBreakpoint || "sm")} {
            position: static;
        }
    `};
    @media print {
        position: static;
        page-break-inside: avoid;
    }

    ${injectCss}
`;

const XngSticky: FC<XngStickyProps> = ({ className = "xng-sticky", stopBreakpoint = "sm", ...props }) => {
    const stickyHeader = useAppSelector(state => (state as CustomAppState).xHeader.stickyHeader || "90px");
    return (
        <XngStickyWrapper
            className={className}
            stopBreakpoint={stopBreakpoint}
            {...props}
            stickyOffset={`${parseFloat(stickyHeader) + 10}px`}
        />
    );
};

export default XngSticky;
